import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { Container } from '../components/ui';
import Reveal from '../components/Reveal';
import Icon from '../components/Icon';
import LeadForm from '../components/LeadForm';
import { CheckList } from '../components/cards';
import { HERO_STATS } from '../data/content';

export default function Demo() {
  const { t } = useLanguage();
  const benefits = t('demo.benefits');
  return (
    <section className="relative overflow-hidden px-5 py-16 sm:px-8 sm:py-20">
      <div className="bp-grid-bg pointer-events-none absolute inset-0 opacity-30" />
      <Container className="relative">
        <div className="grid grid-cols-1 items-start gap-12 lg:grid-cols-2">
          <Reveal>
            <span className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.18em] text-brand"><span className="h-1.5 w-1.5 rounded-full bg-brand" /> {t('nav.requestDemo')}</span>
            <h1 className="mt-4 font-display text-3xl font-extrabold leading-tight text-slate-900 dark:text-white sm:text-4xl">{t('demo.title')}</h1>
            <p className="mt-4 max-w-lg text-base leading-relaxed text-slate-600 dark:text-slate-300">{t('demo.subtitle')}</p>
            {Array.isArray(benefits) && <CheckList className="mt-7" items={benefits} />}
            <div className="mt-10 grid grid-cols-2 gap-4 sm:grid-cols-4">
              {HERO_STATS.map((s) => (
                <div key={s.label}>
                  <div className="font-display text-xl font-bold text-brand">{s.value}</div>
                  <div className="mt-0.5 text-[11px] leading-snug text-slate-500 dark:text-slate-400">{s.label}</div>
                </div>
              ))}
            </div>
          </Reveal>
          <Reveal delay={80}>
            <LeadForm source="demo" submitLabel={t('form.submitDemo')} />
          </Reveal>
        </div>
      </Container>
    </section>
  );
}
